import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { FieldEnum } from '../../../common/FieldEnum';
import { InputField } from '../../../common/SemanticWrapper';
import { InputMode } from '../../../common/FormEnum';

class ChangeNumberForm extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.valid !== this.props.valid) {
      this.props.setIsValid(nextProps.valid);
    }
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Field
                name={'studentId'}
                component={InputField}
                type="number"
                label={'Student Number'}
                disabled={true}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={FieldEnum.Id}
                component={InputField}
                maxLength={12}
                label={'New Student Number'}
                autoFocus={true}
                mode={InputMode.Integer}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (!values[FieldEnum.Id]) {
    errors[FieldEnum.Id] = 'Student number required';
  }

  if (values['studentId'] === values[FieldEnum.Id]) {
    errors[FieldEnum.Id] = 'Student number must be different';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'AccountSetupChangeNumberForm',
})(ChangeNumberForm);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/ChangeNumberForm.js